export default __webpack_public_path__ + "static/media/open-new-window.23a2f512.svg";